export default __webpack_public_path__ + "static/media/Maggiore.7683084c.png";